import { useEffect, useRef } from 'react';

export function useScrollToBottom(messages, isTyping) {
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  // 📜 Défilement automatique vers le bas des messages
  useEffect(() => {
    if (messagesEndRef.current && (messages.length > 1 || isTyping)) {
      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
        });
      }, 100);
    }
  }, [messages, isTyping]);

  return { messagesEndRef, inputRef };
}
